module.exports = __webpack_public_path__ + "img/add_row_after.31cd69b.svg";